import React from "react";
import EnumWalletTypes from "@wallet-manager/node-types/dist/types/postgres/const/WalletType";
import AddressBookSuggestion from "../../../../../components/AddressBookSuggestion";
import { AddressBookOrder } from "../../types";
import {
  AddressBookFilterType,
  createAddressBookFilterConfig,
} from "src/utils/AddressBookFilter/createAddressBookFilter";
import { useTranslation } from "src/hooks";

interface WalletAddressFieldProps {
  addressBookOrder: AddressBookOrder;
  chainName: string;
  onFieldChange: (name: keyof AddressBookOrder, value: string) => void;
}

const WalletAddressField = ({
  addressBookOrder,
  chainName,
  onFieldChange,
}: WalletAddressFieldProps) => {
  const { translate } = useTranslation("createSwapRequest");

  const EOAWalletConfig = createAddressBookFilterConfig(
    AddressBookFilterType.EOAHotWallet,
    { t: translate }
  );
  const ContractWalletConfig = createAddressBookFilterConfig(
    AddressBookFilterType.ContractHotWallet,
    { t: translate }
  );

  return (
    <AddressBookSuggestion
      item={addressBookOrder}
      isAllowFreeInput={false}
      isDisabled={false}
      walletTypes={[String(EnumWalletTypes.HotWallet)]}
      filterConfigs={[EOAWalletConfig, ContractWalletConfig]}
      chain_name={chainName}
      setField={onFieldChange}
    />
  );
};

export default WalletAddressField;
